<template>
  <div :class="$style.modalBox">
    <div :class="$style.content">
      <h3 :class="$style.modalTitle">
        {{ title }}
      </h3>
      <p :class="$style.modalText">
        <slot/>
      </p>
    </div>
    <div :class="$style.modalButtons">
      <MobileButton v-if="!cancelDisabled"
                    :class="$style.mobileButton"
                    btn-style="plain"
                    @click="cancel">
        {{ cancelText }}
      </MobileButton>
      <MobileButton :class="$style.mobileButton"
                    btn-style="plain"
                    @click="confirm">
        {{ confirmText }}
      </MobileButton>
    </div>
  </div>
</template>

<script>
import Component from 'vue-class-component';
import Vue from 'vue';
import MobileButton from '@/apps/mobile/components/MobileButton';

/**
 * Component for generation content for confirmation modals
 * with two buttons (No, Yes)
 *
 * PROPS:
 * @prop {String} message - message for confirmation
 * @prop {String} confirmText - text for YES button
 * @prop {String} cancelText - text for NO button
 *
 * EVENTS:
 * cancel - when YES button clicked
 * confirm - when NO button clicked
 */
@Component({
  components: {
    MobileButton,
  },
  props: {
    title: {
      type:    String,
      default: 'Confirm',
    },
    confirmText: {
      type:    String,
      default: 'Yes',
    },
    cancelText: {
      type:    String,
      default: 'No',
    },
    cancelDisabled: {
      type:     Boolean,
      default:  false,
      required: false,
    },
  },
})
export default class MobileConfirmDialog extends Vue {
  cancel() {
    this.$emit('cancel');
  }

  confirm() {
    this.$emit('confirm');
  }
}
</script>

<style lang="scss" module>
@import '@/style/variables.scss';
@import '@/style/helpers.scss';

.modalBox {
  width: 100%;
  max-width: 270px;
  border-radius: 14px;
  background-color: $mobile-dialog-bg-color;
  overflow: hidden;
}

.content {
  padding: 18px;
}

.modalTitle {
    color: $black;
    font-size: rem(17px);
    font-weight: 700;
    letter-spacing: rem(-0.41px);
    text-align: center;
}

.modalText {
  margin-top: 20px;
  font-size: rem(13px);
  letter-spacing: rem(-0.08px);
  text-align: center;
}

.modalButtons {
  border-top: 1px solid $modals-border;
  display: flex;
}

.mobileButton {
  flex: 100%;

  &+& {
    border-left: 1px solid $modals-border;
  }
}

</style>




// WEBPACK FOOTER //
// src/apps/mobile/components/MobileConfirmDialog.vue